// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invoice-filter-select[data-v-6fd24246]  .vs__selected-options {\n  flex-wrap: nowrap;\n}\n.invoice-filter-select[data-v-6fd24246]  .vs__selected {\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
